// 환경변수 단일 진입점. fallback 값을 한 곳에서 관리.

import { normalizeSiteUrl } from './site';

export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL || 'http://localhost:8282';

/**
 * 공개 카탈로그 정본 도메인 — canonical / OG / JSON-LD 의 절대 URL 기준.
 *
 * fallback 이 운영값인 것은 의도 — 빌드가 배포 서버에서 돌고 VITE_* 는 서버 .env 에서 읽히므로
 * 필수 변수로 두면 누락 시 canonical 이 localhost 로 나간다. 백엔드 frontend.url 기본값과 같은 값.
 * 다만 그 대가로 **dev 빌드도 이 값을 쓴다** — dev 를 갈라내려면 dev 서버 `.env` 에 이 변수를 넣는다.
 * 정적 HTML(og:url 등)과 robots.txt 도 같은 값을 따르며, 결정은 `vite.config.ts` 가 한다.
 */
export const SITE_URL: string = normalizeSiteUrl(import.meta.env.VITE_SITE_URL);
